import { render } from "./campaing-donation.vue?vue&type=template&id=c8754058&scoped=true"
import script from "./campaing-donation.vue?vue&type=script&lang=js"
export * from "./campaing-donation.vue?vue&type=script&lang=js"

import "./campaing-donation.vue?vue&type=style&index=0&id=c8754058&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8754058"]])

export default __exports__